import { useQueryClient } from '@tanstack/react-query';
import { useMutationState } from '~/hooks/reactQuery/useMutationState';
import { QueryKeys } from '../queryKeys';
export const useUpdateSalesTaxConfig = ()=>{
    const queryClient = useQueryClient();
    const { mutate, isPending } = useMutationState({
        // TODO(ANCR-20-BE): fire api.vendor.updateBusinessSettings({ ...settings, salesTax }) once Phase 12 wires the endpoint.
        mutationFn: async (next)=>next,
        onSuccess: (next)=>queryClient.setQueryData([
                QueryKeys.SalesTaxConfig
            ], next)
    });
    return {
        updateSalesTaxConfig: mutate,
        isLoading: isPending
    };
};
